import React, { useEffect, useState } from "react";

import type { Theme } from "@excalidraw/element/types";

import { defaultLang, languages, setLanguage } from "../i18n";

import { LoadingMessage } from "./LoadingMessage";

import type { Language } from "../i18n";

interface Props {
  langCode: Language["code"];
  children: React.ReactElement;
  theme?: Theme;
}

export const InitializeApp = (props: Props) => {
  // If the lang is the default (English), it's already bundled — no async load needed
  const isDefaultLang =
    !props.langCode || props.langCode === defaultLang.code;
  const [loading, setLoading] = useState(!isDefaultLang);

  useEffect(() => {
    const currentLang =
      languages.find((lang) => lang.code === props.langCode) || defaultLang;

    if (currentLang.code === defaultLang.code) {
      // English is already ready — just update document attributes synchronously
      setLanguage(currentLang);
      setLoading(false);
      return;
    }

    const updateLang = async () => {
      await setLanguage(currentLang);
      setLoading(false);
    };
    updateLang();
  }, [props.langCode]);

  return loading ? <LoadingMessage theme={props.theme} /> : props.children;
};
